import DataTable from "../../components/DataTable/DataTable";
import {Tag, Tooltip} from "antd";
import {getReadableTimeFromTimeStamp} from "../../utilities/common";

const levelColor = {
    INFO: 'blue',
    WARNING: 'orange',
    ERROR: 'red',
};

const MGSLogPage = () => {

    const columns = [
        {
            title: 'Timestamp',
            dataIndex: 'timestamp',
            key: 'timestamp',
            width: '20%',
            render: (text) => text ? getReadableTimeFromTimeStamp(text) : '-',
        },
        {
            title: 'Level',
            dataIndex: 'level',
            key: 'level',
            width: '10%',
            render: (text) => (
                <Tag color={levelColor[text] || 'default'}>{text}</Tag>
            ),
        },
        {
            title: 'Machine ID',
            dataIndex: 'machineNumber',
            key: 'machineNumber',
            width: '15%',
        },
        {
            title: 'Message',
            dataIndex: 'message',
            key: 'message',
            width: '55%',
            ellipsis: true,
            render: (text) => (
                <Tooltip title={text} placement={'leftTop'}>
                    <div style={{ wordWrap: 'break-word', wordBreak: 'break-all' }}>{text}</div>
                </Tooltip>
            ),
        },
    ];

    return (
        <DataTable
            reload={true}
            pageTitle={'MGS Logs'}
            columns={columns}
            url="/api/v1/machines/mgs_logs/"
            pagination={true}
            hideHeader={true}
        />
    );
};

export default MGSLogPage;
